const nf = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2 });

export const fmt = (n) => (n === null || n === undefined || n === "" ? "" : nf.format(Number(n)));

export const ddmmyyyy = (d) => {
  if (!d) return "";
  const [y, m, dd] = d.split("-");
  return `${dd}-${m}-${y}`;
};

export const todayISO = () => {
  const t = new Date();
  return new Date(t.getTime() - t.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export const when = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}-${p(d.getMonth() + 1)}-${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

export const isZero = (n) => Math.abs(Number(n) || 0) < 0.0001;

export const num = (v) => (v === "" || v === null || v === undefined || v === "-" ? 0 : Number(v));
